const experienceData = [
    {
      id: 4,
      position: "Software Developer",
      company: "University of Toronto - IQBank",
      dateRange: "September 2025 — Present",
      location: "Toronto, ON",
      description: `I shipped anonymous posting and dark mode features in React and TypeScript, lifting user engagement by 45%. I built a front-end test suite from scratch and integrated it into GitHub Actions to prevent UI regressions. I refactored components, led collaborative code reviews, and prepared demos and notes for the ARIA conference.`,
      skills: ["React", "TypeScript", "Express.js", "Vitest", "Prisma", "Tailwind"],
    },
    {
      id: 1,
      position: "Software Engineer Intern",
      company: "BlueCat",
      dateRange: "May 2024 — September 2025",
      location: "Toronto, ON",
      description: `I contributed to a TypeScript and React front-end overhaul. I optimized components and fixed critical defects to accelerate a major product release. Also, I developed REST API endpoints in Java and fixed PostgreSQL queries. I wrote system tests using JUnit to help reduce test failures by 15%. Additionally, I maintained Jest test suites to increase coverage by 30%. I also supported team onboardings for the new UI, performed code reviews, and provided guidance to ensure smooth transitions for new engineers.`,
      skills: ["TypeScript", "React", "Java", "JUnit", "Jest", "PostgreSQL", "Selenium"],
    },
    {
      id: 2,
      position: "Software Developer",
      company: "UNICEF",
      dateRange: "September 2023 — December 2023",
      location: "Toronto, ON",
      description: `I helped develop an open-source web application using Python, JavaScript, and React to replace a command line proof-of-concept in an agile team for over 100 UNICEF offices worldwide to save licensing costs. I implemented a cloud-based version control feature using Firebase and Flask to allow large teams to effectively manage multiple dashboards and propagate changes to clones. I created a cloning feature across multiple instances of Superset to allow for a seamless transition between staging and production environments to reduce deployment time.`,
      skills: ["Python", "Flask", "Firebase", "JavaScript", "React"],
    },
    {
      id: 3,
      position: "Data Science Course Development Assistant",
      company: "University of Toronto - Deptartment of Statistics",
      dateRange: "May 2023 — August 2023",
      location: "Toronto, ON",
      description: `I integrated Pandas and Statsmodels into Python coding and tutorial exercises to enhance the understanding of applications of data science techniques for over 600 students. Also, I worked with the professor to coordinate efforts using Git and created comprehensive unit tests resulting in effective management of issues, code reviews, and updated lecture material.`,
      skills: ["Python", "NumPy", "Pandas", "Statsmodels"],
    },
  ];
  
  export default experienceData;